export default __webpack_public_path__ + "static/media/logo.ddd0fbc3.png";